module.exports = __webpack_public_path__ + "img/qs_pc.da7d80f0.png";